module.exports = __webpack_public_path__ + "img/marker.2ab54d2b.svg";